export default class MakingRequestException extends Error {

    constructor(message: string) {
        super(message);
        this.name = 'Making Request Exception';
    }
}